
import { Component, Vue } from "vue-property-decorator";
import {
  jobCategoryList,
  jobCategoryListSearch,
  jobSearch,
  jobDetail
} from "@/axios/request/job";
@Component
export default class RecruitCategoryDetail extends Vue {
  jobKey = "";
  category = "";
  tableData = [];
  currentPage = 1;
  pageSize = 8;
  total = 0;
  loading = false;
  loadingButton = false;
  recruitType = this.$route.query.navSelect || '1'
  isSearchKey = false;

  async search() {
    if (!this.jobKey) {
      this.setCategoryList(this.category)
      return
    }
    try {
      this.loading = true;
      this.loadingButton = true;
      this.currentPage = 1;
      const { data: res } = await jobSearch(this.jobKey,1, this.recruitType);
      this.tableData = res.data.list;
      this.total = Number(res.data.total);
      this.pageSize = 8;
      window.sessionStorage.removeItem("categoryId");
      window.sessionStorage.removeItem("categoryName");
      this.$bus.$emit("editCategoryActive", true);
      this.loading = false;
      this.loadingButton = false;
      this.isSearchKey = true;
    } catch {
      this.loading = false;
      this.loadingButton = false;
      return;
    }
  }
  async handleCurrentChange(val: number) {
    try {
      this.loading = true;
      this.currentPage = val;
      if (this.isSearchKey && this.jobKey) {
        const { data: res } = await jobSearch(this.jobKey,val, this.recruitType);
        this.tableData = res.data.list;
        this.total = Number(res.data.total);
      } else {
        const { data: res } = await jobCategoryListSearch(this.category, val, this.recruitType);
        this.tableData = res.data.list;
        this.total = Number(res.data.total);
      }
      this.loading = false;
    } catch {
      this.loading = false;
      return;
    }
  }
  async setCategoryList(category: string) {
    try {
      this.isSearchKey = false;
      this.loading = true;
      this.currentPage = 1;
      const { data: res } = await jobCategoryListSearch(category, 1, this.recruitType);
      // 上方已初始化为8
      this.pageSize = 8;
      this.tableData = res.data.list;
      this.total = Number(res.data.total);
      this.loading = false;
    } catch {
      this.loading = false;
      return;
    }
  }
  async toJobDetail(row: any) {
   // 判断职位是否下线
   const { data: res } = await jobDetail(row.Code)
    if (res.data.Status == 2) {
      this.$confirm(
        "该职位已下线，请选择其他职位",
        {
          confirmButtonText: "好的",
          dangerouslyUseHTMLString: false,
          showCancelButton: false,
          showClose: false,
          callback: () => {
            this.$router.push({
            path: "/home",
            query: {
              navSelect: '1'
            },
          });
          }
        }
      )
      return
    }

    this.$router.push({
      path: "/job",
      query: { JobCode: row.Code, recruitType: this.recruitType },
    });
  }
  setCategoryName() {
    const categoryName = window.sessionStorage.getItem("categoryName");
    categoryName ? (this.category = categoryName) : null;
  }
  created() {
    this.setCategoryName();
    this.setCategoryList(this.category);
  }
  mounted() {
    this.$bus.$on("updateCategoryDetail", (data: boolean) => {
      if (data) {
        this.jobKey = "";
        this.setCategoryName();
        this.setCategoryList(this.category);
      }
    });
  }
  beforeDestroy() {
    this.$bus.$off("updateCategoryDetail");
  }
}
